import { useTranslation } from "react-i18next";
import { useEndpoints } from "./useEndpoints";

import { getStorageItem, removeStorageItem } from "../utils/localStorage";
import { NavigateFunction } from "react-router-dom";
import { RoutesRouter } from "../models/Routes";

export const useInterceptor = () => {
  const validateToken = async (
    options: RequestInit,
    navigate: NavigateFunction
  ) => {
    const token = getStorageItem("token");
    if (!token) {
      /*    tokenNotExists(request, navigate); */
      return;
    }
    const { accessToken, expiresIn, date } = token;
    const expireDate = new Date(date);
    expireDate.setSeconds(expireDate.getSeconds() + expiresIn);
    if (new Date() > expireDate) {
      removeStorageItem("me");
      removeStorageItem("token");
      navigate(RoutesRouter.login);
    }
    accessToken &&
      (options.headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      });
  };

  const fetchInterceptor = (
    fetchFn: typeof fetch,
    navigate: NavigateFunction
  ) => {
    const endpointWithHeader = [
      "/auth/me",
      "/companies",
      "/categories",
      "/questions",
      "/template",
      "/resources",
      "/issues"
    ];

    const fetchWithInterceptor = async (url: string, options: RequestInit) => {
      if (endpointWithHeader.some((endpoint) => url.includes(endpoint))) {
        await validateToken(options, navigate);
      }

      return fetchFn(url, options);
    };

    return fetchWithInterceptor;
  };

  const jwtInterceptor = (navigate: NavigateFunction) => {
    const originalFetch = fetch;
    const fetchWithInterceptor = fetchInterceptor(originalFetch, navigate);

    (window as any).fetch = fetchWithInterceptor;
  };
  return { jwtInterceptor, validateToken };
};
